module.exports = __webpack_public_path__ + "img/2012-12-14 18.19.51.d1c9e78c.jpg";